// extracted by mini-css-extract-plugin
export var quillEditor = "_kb-1";
export var variable = "_kb-0";